import React from 'react';
import PropTypes from 'prop-types';

const YesNoNaToggle = ({ value, onChange, disabled = false }) => {
  const normalizedValue = String(value || 'no').toLowerCase();
  const isYes = normalizedValue === 'yes';
  const isNo = normalizedValue === 'no';
  const isNa = normalizedValue === 'na';

  const handleSelect = (val) => {
    if (disabled) return;
    onChange(val);
  };

  return (
    <div 
      className="yes-no-na-toggle-container"
      style={{
        display: 'inline-flex',
        background: '#f1f5f9',
        padding: '4px',
        borderRadius: '8px',
        border: '1px solid #cbd5e1',
        pointerEvents: disabled ? 'none' : 'auto',
        opacity: disabled ? 0.65 : 1,
      }}
    >
      <button
        type="button"
        onClick={() => handleSelect('yes')}
        style={{
          background: isYes ? '#2563eb' : 'transparent',
          color: isYes ? '#ffffff' : '#475569',
          border: 'none',
          borderRadius: '6px',
          padding: '6px 16px',
          fontWeight: 600,
          fontSize: '14px',
          transition: 'all 0.2s ease',
          boxShadow: isYes ? '0 1px 3px rgba(37, 99, 235, 0.3)' : 'none',
          cursor: disabled ? 'not-allowed' : 'pointer',
        }}
      >
        Yes
      </button>
      <button
        type="button"
        onClick={() => handleSelect('no')}
        style={{
          background: isNo ? '#2563eb' : 'transparent',
          color: isNo ? '#ffffff' : '#475569',
          border: 'none',
          borderRadius: '6px',
          padding: '6px 16px',
          fontWeight: 600,
          fontSize: '14px',
          transition: 'all 0.2s ease',
          boxShadow: isNo ? '0 1px 3px rgba(37, 99, 235, 0.3)' : 'none',
          cursor: disabled ? 'not-allowed' : 'pointer',
        }}
      >
        No
      </button>
      <button
        type="button"
        onClick={() => handleSelect('na')}
        style={{
          background: isNa ? '#2563eb' : 'transparent',
          color: isNa ? '#ffffff' : '#475569',
          border: 'none',
          borderRadius: '6px',
          padding: '6px 16px',
          fontWeight: 600,
          fontSize: '14px',
          transition: 'all 0.2s ease',
          boxShadow: isNa ? '0 1px 3px rgba(37, 99, 235, 0.3)' : 'none',
          cursor: disabled ? 'not-allowed' : 'pointer',
        }}
      >
        NA
      </button>
    </div>
  );
};

YesNoNaToggle.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default YesNoNaToggle;
